exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoomD{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;margin:0 auto;text-align:center}.zoomD,.zoomD:hover{background-color:#fff}.zoomD:hover{-webkit-transform:scale(1.02);transform:scale(1.02)}", ""]);

// exports
